import * as gfunctions from './generalFunctions';

CCL.dropdownSelect = {
  autoload: [
    ['selectDrop', $('.c-dropdown').length > 0],
    ['dropImgRotate', $('.c-dropdown').length > 0],
    ['enableScrollToTop', $('#scrollToTop-CCL').length > 0],
    ['stickyOrderSummary', $('.c-order-summary').length > 0],
    ['collapseOpenedAccordian', $('.gift-card-balance').length > 0],
    ['cclAdaFocus', $('body').length > 0],
    ['pdpSticky', $('.c-pdp-card-move-up').length > 0],
    ['enableADAForModals', $('.modal').length > 0],
    ['pdpCardScroll', $('c-pdp-template-one'.length > 0)],
    ['hideEmptyPlaceholder', $('body').length > 0],
    ['ProcessingMessage', $('.err-text-wrapper').length > 0],
    ['shopByCategoryhideEmptyPlaceholder', $('.shop-by-category-empty-placeholder').length > 0],
    ['todoPlannerhideEmptyPlaceholder', $('.todo-planner-empty-placeholder').length > 0],
    ['iframeScreenHide', $('body').length > 0],
    ['notificationCount', $('.notification-dropdown-anchor').length > 0]
  ],

  triggeredElementClass: '',
  scrollPosition: '',
  focusedElementClass: '',

  notificationCount() {
    $.ajax({
      type: 'GET',
      url: '/shop/webinbox/messagecount'
    }).done((response) => {
      const notContainer = $('.notification-count');
      if (response && response.unread) {
        if (response.unread > 99) {
          notContainer.text('99+');
        } else {
          notContainer.text(response.unread);
        }
        $('.notification-dropdown-anchor').attr('aria-label', `You have ${response.unread} unread notification, Visit notification center to view all notifications`);
        notContainer.removeClass('d-none');
      } else {
        notContainer.addClass('d-none');
      }
      const pageName = ACC.pageName; // eslint-disable-line
      if (pageName.toLowerCase().includes('inbox')) {
        gfunctions.hideLoader();
      }
    }).fail(() => {
      console.log('error while loading notification count');
      gfunctions.hideLoader();
    });
  },

  refreshHybrisCount(count) {
    const notContainer = $('.notification-count');
    notContainer.removeClass('d-none');
    if (count) {
      if (count > 99) {
        notContainer.text('99+');
      } else {
        notContainer.text(count);
      }
      $('.notification-dropdown-anchor').attr('aria-label', `You have ${count} unread notification, Visit notification center to view all notifications`);
    } else {
      notContainer.addClass('d-none');
    }
  },

  enableADAForModals() {
    $('.modal').on('hidden.bs.modal', (e) => {
      const replacedClass = this.triggeredElementClass.replace(/\s/g, '.');
      if (replacedClass) {
        this.focusedElementClass = `.${replacedClass}`;
        $('body').addClass('ccl-ada-focus');
        //  $(`.${replacedClass}`).trigger('touchstart'); // Added for Iphone
        setTimeout(() => {
          $(`.${replacedClass}`).addClass('ada-element-focus');
          $(`.${replacedClass}`).focus();
        }, 800);
      }

      // Added this for Iphone focus
      // $(`.${replacedClass}`).on('touchstart', () => {
      //   $(`.${replacedClass}`).focus();
      // });
    });

    $('.modal').on('show.bs.modal', (event) => {
      this.triggeredElementClass = event.delegateTarget.ownerDocument.activeElement.className;
      // this.scrollPosition = $(window).scrollTop();
    });
  },

  handleScroll_Mobile() {
    const metaTag = $('#viewport');
    console.dir(metaTag);
    // metaTag[0].attr('content', contentInfo);
  },

  ProcessingMessage() {
    setTimeout(() => {
      $('.err-text').attr({ role: 'alert', 'aria-live': 'assertive' });
    }, 500);
    setTimeout(() => {
      $('.err-title').attr({ role: 'alert', 'aria-live': 'assertive' });
    }, 1500);
  },

  dropImgRotate() {
    $('.btn-dropdown').click((event) => {
      $('.btn-dropdown img').toggleClass('img-rotate');
    });
  },

  selectDrop() {
    $('.dropdown-item').click((event) => {
      const { value } = event.currentTarget.dataset;
      $('.dropdown-val').empty().html(value);
      $('.btn-dropdown img').toggleClass('img-rotate');
    });
  },

  collapseOpenedAccordian() {
    const $categoryFacetsGroup = $('#category-facets-accordion');
    $categoryFacetsGroup.on('show.bs.collapse', '.collapse', () => {
      $categoryFacetsGroup.find('.collapse.show').collapse('hide');
    });
  },

  enableScrollToTop() {
    const getScrolledPosition = $(window).scrollTop();
    if (getScrolledPosition <= 10) {
      $('#scrollToTop-CCL').fadeOut();
    }
    $(window).scroll(() => {
      const scrolledPosition = $(window).scrollTop();
      if (scrolledPosition >= 100) { // If page is scrolled more than 100px
        $('#scrollToTop-CCL').fadeIn(200); // Fade in the arrow
      } else {
        $('#scrollToTop-CCL').fadeOut(200); // Else fade out the arrow
      }
    });
  },

  stickyOrderSummary() {
    if ($('.sticky-total').length > 0) {
      if (!$('body').find('.sticky-total-arrow').length) {
        $('.sticky-total').append('<img src="/_ui/responsive/ccl/assets/icons/down_blue.svg" alt="arrow image" class="sticky-total-arrow">');
      }
    }
    $(window).scroll(() => {
      if (window.innerWidth <= 1080) {
        if (gfunctions.isElementPartiallyInViewport($('.c-order-summary'))) {
          $('.mobile-sticky-order-summary').slideUp();
        } else {
          $('.mobile-sticky-order-summary').slideDown();
        }
      }
    });

    $('body').on('click keypress', '.sticky-total', (e) => {
      $('html, body').animate({
        scrollTop: $('.c-order-summary').offset().top
      }, 1200);
    });
  },

  cclAdaFocus() {
    $(document).on('keydown click', (event) => {
      if (event.which === 9) {
        $('body').addClass('ccl-ada-focus');
      }
    });
    $('body').on('keydown click', (event) => {
      if (event.type === 'click') {
        $('body').removeClass('ccl-ada-focus');
      } else if (event.which === 13) {
        $('body').addClass('ccl-ada-focus');
      } else {
        $('body').addClass('ccl-ada-focus');
      }
    });
  },

  hideEmptyPlaceholder() {
    $(window).on('load', () => {
      $('.empty-placeholder').css('display', 'none');
      $('.product-carousel-container').fadeIn('slow');

      // $('.empty-placeholder').css('display', 'none');
      // $('.product-carousel-container').fadeIn('slow');

      $('body').on('keypress', '.sharethis-inline-share-buttons .st-btn', (e) => {
        if (e.which === 13) {
          $(e.currentTarget).trigger('click');
        }
      });

      // setTimeout(() => {
      //   $('.sharethis-inline-share-buttons').addClass('d-none');
      // }, 500);

      setTimeout(() => {
        $('body').find('.sharethis-inline-share-buttons .st-btn').each((index, elem) => {
          $(elem).attr('tabindex', '-1');
          const alt = $(elem).find('img').attr('alt');
          $(elem).find('img').attr('aria-label', `${alt}. Opens a new tab to an external website.`);
          $(elem).find('img').removeAttr('alt');
          $(elem).attr('role', 'button');
          $(elem).css('display', 'inline-block');
        });
        $('.sharethis-inline-share-buttons .st-btn img').attr('aria-hidden', 'true');
        $('.sharethis-inline-share-buttons .st-btn').attr('aria-hidden', 'true');
      }, 1000);

      $('body').on('click keypress', '.pdp-share-link', (e) => {
        $('.pdp-share-link').attr('aria-expanded', (index, attr) => {
          if (attr === 'false') {
            $('.add-to-fav, .remove-from-fav').attr('tabindex', '-1');
          } else {
            $('.add-to-fav, .remove-from-fav').removeAttr('tabindex');
          }
          return attr === 'true' ? 'false' : 'true';
        });
        if (!$('.sharethis-inline-share-buttons').is(':visible')) {
          $('.sharethis-inline-share-buttons').css('opacity', '1').show();
          $('body').find('.sharethis-inline-share-buttons .st-btn').each((index, elem) => {
            $(elem).attr('tabindex', '0');
          });
          $('.sharethis-inline-share-buttons .st-btn').attr('aria-hidden', 'false');
          $('.sharethis-inline-share-buttons .st-btn img').attr('aria-hidden', 'false');
          $('.sharethis-inline-share-buttons').attr('tabindex', '0');
          // $('.pdp-social-share').trigger('focus');
        } else {
          $('.sharethis-inline-share-buttons').css('opacity', '0').hide();
          $('.sharethis-inline-share-buttons .st-btn').attr('aria-hidden', 'true');
          $('.sharethis-inline-share-buttons .st-btn img').attr('aria-hidden', 'true');
          $('body').find('.sharethis-inline-share-buttons .st-btn').each((index, elem) => {
            $(elem).attr('tabindex', '-1');
            $('.sharethis-inline-share-buttons').attr('tabindex', '-1');
          });
        }

        // $('.sharethis-inline-share-buttons').toggleClass('d-none');
      });

      $('body').on('click keydown', '.pdp-share-link', (e) => {
        if (e.which === 9) {
          if (Number($('.sharethis-inline-share-buttons').css('opacity')) === 1) {
            e.stopPropagation();
            e.preventDefault();
            $('.st-first').trigger('focus');
          }
        }
      });

      $('body').on('click keydown', '.st-last', (e) => {
        if (e.which === 9) {
          e.stopPropagation();
          e.preventDefault();
          $('.pdp-share-link').trigger('focus');
        }
      });
    });

    // window.onload = () => {
    //   $('.empty-placeholder').css('display', 'none');
    //   $('.product-carousel-container').fadeIn('slow');

    //   $('body').find('.sharethis-inline-share-buttons .st-btn').each((index, elem) => {
    //     $(elem).attr('tabindex', '0');
    //     const alt = $(elem).find('img').attr('alt');
    //     $(elem).find('img').attr('aria-label', `${alt}. Opens a new tab to an external website.`);
    //     $(elem).find('img').removeAttr('alt').attr('role', 'button');
    //   });

    //   $('body').on('keypress', '.sharethis-inline-share-buttons .st-btn', (e) => {
    //     if (e.which === 13) {
    //       console.log('key is pressed');
    //       $(e.currentTarget).trigger('click');
    //     }
    //   });
    // };
  },

  todoPlannerhideEmptyPlaceholder() {
    $('.todo-planner-empty-placeholder').css('display', 'none');
    $('#todoPlanner').fadeIn('slow');
  },

  shopByCategoryhideEmptyPlaceholder() {
    $('.shop-by-category-empty-placeholder').css('display', 'none');
    $('.shop-by-category-carousel').fadeIn('slow');
  },

  pdpCardScroll() {
    // if (!gfunctions.detectmob()) {
    //   const cardHeight = $('.c-pdp-card').height();
    //   if (cardHeight > window.innerHeight) {
    //     $('.c-pdp-card').css('height', `${window.innerHeight - 10}px`);
    //   }
    // }
  },

  pdpSticky() {
    // $(window).scroll(() => {
    //   if (!gfunctions.detectmob()) {
    //     const offset = 0;
    //     let sticky = false;
    //     const top = $(window).scrollTop();
    //     const $container = $('.c-pdp-card').closest('.container');
    //     const elemTop = $('.c-pdp-card').position().top;
    //     const elemBottom = elemTop + $('.c-pdp-card').height();
    //     const $productDetailsTop = $('.c-product-details').offset().top;
    //     const $productDetailsHeight = $('.c-product-details').height();
    //     const $productDetailsBottom = $productDetailsTop + $productDetailsHeight;
    //     const conPosRight = ($(window).width() - $container.outerWidth()) / 2;
    //     if ((elemBottom + top) > $productDetailsBottom) {
    //       $('.c-pdp-card').addClass('banner-card-sticky');
    //     } else {
    //       $('.c-pdp-card').removeClass('banner-card-sticky');
    //     }
    //     if (($('.pdp-sticky-wrap').offset().top - 650) < top + 32) {
    //       $('.c-pdp-card').addClass('banner-card-fixed');
    //       $('.c-pdp-card').css('right', `${conPosRight}px`);
    //       sticky = true;
    //     } else {
    //       $('.c-pdp-card').removeClass('banner-card-fixed');
    //       $('.c-pdp-card').css('right', '0');
    //     }
    //   }
    // });
  },

  iframeScreenHide() {
    $('#st_gdpr_iframe').attr('tabindex', '-1');
    $('#st_gdpr_iframe').attr('aria-hidden', 'true');
    $('#st_gdpr_iframe').attr('hidden', 'hidden');
  }
};



// WEBPACK FOOTER //
// ./src/js/utils.js